import { useState } from 'react'

interface UseHoverReturn {
  isHovered: boolean
  hoverProps: {
    onMouseEnter: () => void
    onMouseLeave: () => void
    onFocus: () => void
    onBlur: () => void
  }
}

/**
 * Hook for managing hover state
 * @returns Object containing isHovered state and hover event handlers
 * @example
 * const { isHovered, hoverProps } = useHover()
 * <div {...hoverProps} style={{ color: isHovered ? 'red' : 'blue' }}>
 *   Hover me
 * </div>
 */
export function useHover(): UseHoverReturn {
  const [isHovered, setIsHovered] = useState(false)

  return {
    isHovered,
    hoverProps: {
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      onFocus: () => setIsHovered(true),
      onBlur: () => setIsHovered(false),
    },
  }
}
